<template>
  <div class="statistics">
    <div class="container">
      <div class="card">
        <div class="charts-1">
          <!--          <AreaChart />-->
          <LineChart />
        </div>
        <br>
        <hr>
        <br>
        <div class="card-header" style="display: flex; justify-content: space-between">
          <h4>Все согласующие, зажерживающие акты более двух дней в текущем периоде со стороны АО "Мангистаумунайгаз"</h4>
          <!--            <button class="btn-danger" style="border-radius: 5px">Удалить все уведомления</button>-->
        </div>
        <div class="table-responsive">
          <table class="table table-hover table-nowrap">
            <thead class="thead-light">
            <tr>
              <th scope="col" class="">ID акта</th>
              <th scope="col" class="">Наименование</th>
              <th scope="col" class="">Поставщик</th>
              <th scope="col" class="">Статус акта</th>
              <th scope="col" class="">Пользователь</th>
              <th scope="col" class="">Детали</th>
              <th scope="col" class="">Срок</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(approve, index) in this.approves" :key="approve.id" :id="'req-tr-' + approve.id" class="tr-main">
              <td data-label="" class="">
                <router-link class="custom-link" :to="`/acts/${approve.act_id}`">
                  {{ approve.act_id }}
                </router-link>
              </td>
              <td data-label="" class="" :title="approve.act_name">{{ approve.act_name_short }}</td>
              <td data-label="" class="" :title="approve.act_impl_company">{{ approve.act_impl_company_short }}</td>
              <td data-label="" class="">{{ approve.act_status }}</td>
              <td data-label="" class="">{{ approve.user.ouser.full_name }}</td>
              <td data-label="" class="text-center">
                <i class="bx bx-detail" style="color: #6c63ff; transform: scale(1.5)" @click="showPositionModal(approve.id)"></i>
                <modal :name="'position-modal-' + approve.id" :height="500">
                  <div class="p-10">
                    <h4 class="text-center">Подробности</h4>
                    <hr>
                    <div class="div-item">
                      <div class="descripcion">ФИО</div>
                      <div class="precio">{{ approve.user.ouser.full_name }}</div>
                    </div>
                    <div class="div-item">
                      <div class="descripcion">Должность</div>
                      <div class="precio">{{ approve.user.ouser.position }}</div>
                    </div>
                    <div class="div-item">
                      <div class="descripcion">Организация</div>
                      <div class="precio">{{ approve.user.ouser.company.name }}</div>
                    </div>
                    <div class="div-item">
                      <div class="descripcion">Дата акта</div>
                      <div class="precio">{{ approve.act_date }}</div>
                    </div>
                    <div class="div-item">
                      <div class="descripcion">Договор</div>
                      <div class="precio">
                        <router-link class="custom-link" :to="`/contracts/${approve.contract_id}`">
                          {{ approve.contract_data }}
                        </router-link>
                      </div>
                    </div>
                    <div class="div-item">
                      <div class="descripcion">Дата начала согласования</div>
                      <div class="precio">{{ approve.started_datetime_parsed }}</div>
                    </div>
                    <div class="div-item">
                      <div class="descripcion">С момента назначения прошло</div>
                      <div class="precio">{{ approve.time_to_end }}</div>
                    </div>
                  </div>
                </modal>
                <!--                {{ approve.user.ouser.position }}-->
              </td>
              <!--              <td data-label="" class="">{{ approve.started_datetime_parsed }}</td>-->
              <td data-label="" class="">{{ approve.time_to_end }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-5">
          <pagination :pageCount="max_pages" :currentPage="current_page" @pageClicked="getAllApproves" />
        </div>
        <!--        <br>-->
        <!--        <br>-->
        <!--        <div class="charts-1">-->
        <!--            <AreaChart />-->
        <!--&lt;!&ndash;          <LineChart />&ndash;&gt;-->
        <!--        </div>-->
        <br>
        <hr>
        <br>
        <div class="charts">
<!--          <AreaChart />-->
<!--          <LineChart />-->
          <PieChart :abp_data="abp_data"/>
          <Doughnut />
        </div>
        <div class="charts">
          <!--          <AreaChart />-->
          <LineChart23 />
          <LineChart21 />
        </div>
        <br>
      </div>



    </div>
  </div>
</template>

<script>
import Pagination from "../components/shared/Pagination.vue"
import AreaChart from "@/components/charts/AreaChart";
import LineChart from "@/components/charts/LineChart";
import LineChart20 from "@/components/charts/LineChart20";
import LineChart21 from "@/components/charts/LineChart21";
import LineChart23 from "@/components/charts/LineChart23";
import PieChart from "@/components/charts/PieChart";
import Doughnut from "@/components/charts/Doughnut";

export default {
  components: {
    AreaChart,
    LineChart,
    LineChart20,
    LineChart21,
    LineChart23,
    PieChart,
    Doughnut,
    Pagination
  },
  data () {
    return {
      abp_data: [],
      current_page: 1,
      max_pages: 1,
      search_act_contr: "",
      search_act_impl: "",
      search_last_name: "",
      years_list: [
        '2026',
        '2025',
        // '2024',
        // '2023',
        // '2022',
        // '2021',
        // '2020',
        // '2019',
        'Все года'
      ],
      month_list: [
        'Все месяца',
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ],
      fast_filter_year: "2023",
      fast_filter_month: 0,
      all_approves: [],
      approves_global: [],
      approves: []
    }
  },
  created() {
    const d = new Date();
    this.fast_filter_month = d.getMonth() + 1;
    this.getABPStatistics();
    this.getAllApproves(1);
  },
  methods: {
    showPositionModal(index) {
      this.$modal.show("position-modal-" + index);
    },
    getAllApproves(page) {
      this.approves = [];
      this.approves_global = [];
      this.loading = true
      if (page > 0 && page < this.max_pages + 1) {
        this.current_page = page;
        let formData = {
          // status: this.fast_filter,
          page: page,
          // search_act: this.search_act,
          // search_act_ngdu: this.search_act_ngdu,
          search_act_contr: this.search_act_contr,
          search_act_impl: this.search_act_impl,
          search_last_name: this.search_last_name,
          filter_year: this.fast_filter_year,
          filter_month: this.fast_filter_month,
          two_month: '1',
        };
        this.$store.dispatch("getAllApproves", formData).then((response) => {
          this.approves = response.data.results;
          this.approves_global = response.data.results;
          this.all_approves = response.data;
          this.max_pages = parseInt(this.all_approves.count / 10) + 1;
        }).catch((error) => {
          this.$store.dispatch('addNotification', {
            type: 'error',
            message: 'Ошибка: ' + error.response.data.detail,
          })
        });
      }
    },
    fast_active_year(to_filter) {
      if (to_filter.toString() === this.fast_filter_year.toString()) {
        return 'active';
      }
      return '';
    },
    fast_active_month(to_filter) {
      if (to_filter.toString() === this.fast_filter_month.toString()) {
        return 'active';
      }
      return '';
    },
    change_fast_filter_year(curr_filter) {
      this.fast_filter_year = curr_filter;
      this.getAllApproves(1);
    },
    change_fast_filter_month(curr_filter) {
      this.fast_filter_month = curr_filter;
      this.getAllApproves(1);
    },
    getABPStatistics() {
      this.$store.dispatch("getABPStatistics").then((response) => {
        console.log(response.data);
        this.abp_data = response.data.abp_data;
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: 'Ошибка: ' + error.response.data.detail,
        })
      });
    }

  }
}
</script>

<style scoped>
@import "../assets/css/webpixels.css";
.statistics {
  padding-top: 2rem;
}

.charts {
  width: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}
.charts-1 {
  width: auto;
  //display: grid;
  //grid-template-columns: repeat(2, 1fr);
  //gap: 1.5rem;
}

.tr-main {
  cursor: pointer
}

.item-wrap {
  display: flex;
  justify-content: space-between;
}

.left-item ul {
  display: flex;
  justify-content: left;
  gap: 1rem;
}

@media screen and (max-width: 1100px) {
  .left-item {
    flex-direction: column;
    gap: 0.2rem;
    height: 100px !important;
  }
}

.item {
  height: 50px;
  /*width: 50%;*/
}

.innernavbar-wrap {
  width: 100%;
}

.home-section {
  position: relative;
  background: #e4e9f7;
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
}

@media (max-width: 1000px) {
  .home-section {
    left: 0 !important;
  }
}

.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}

.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}

.filter-btn {
  padding-left: 0.8rem !important;
  padding-right: 0.8rem !important;
}

.notification-status {
  padding: .5rem 1rem;
  border-radius: 12px;
}

.unread {
  background: #ebf8ee;
  border: 1px solid #c1e4c9;
}

.read {
  background: #e5effa;
  border: 1px solid #afcdef;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: none;
  outline: none;
  margin: 1rem 0;
  border-radius: 10px;
}

.div-item {
  height: 40px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.descripcion {
  /*background-color: green;*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.descripcion:after {
  content: " ........................................................................................................................................................................................................................................................................................."
}

.precio {
  /*background-color: red;*/
  flex-shrink: 0;
}

</style>
